const searchAndFilterTestIDs = {
  searchScreen: 'search-screen',
  searchInput: 'search-input',
  searchCancelButton: 'search-cancel-button',
  searchResultsItem: 'search-results-item',
  searchResultsFullName: 'search-results-name',
  searchResultsAvatar: 'search-results-item-avatar',
  searchResultsRoleAndGeneration: 'search-results-role-generation',
  searchResultsLabelNoResults: 'search-results-label-no-results',
  searchResultsLabelNoCoachesOrClients:
    'search-results-label-no-coaches-or-clients',
  searchResultsLabelFoundForThisSearch:
    'search-results-label-found-for-this-search',
  searchResultsShowMore: 'search-results-show-more-button',
  searchResultsFilterButtonLabel: 'search-results-filter-button-label',
  searchResultsFilterButton: 'search-results-filter-button',
  searchResultsCount: 'search-results-count',
  avatar: 'avatar',
  noRecentSearchesTopHeader: 'search-no-recent-top-header',
  noRecentSearchesBodyHeader: 'search-no-recent-body-header',
  noRecentSearchesLabel: 'search-no-recent-body-label',
  recentSearchesTopHeader: 'search-recent-top-header',
  recentSearchesClearAllButton: 'search-recent-clear-all-button',

  searchFilterClearAllFilters: 'search-filter-clear-button',
};

export default searchAndFilterTestIDs;
